// extracted by mini-css-extract-plugin
export var csatScore = "_kz-5";
export var header = "_kz-1";
export var panelWrapper = "_kz-2";
export var postPreview = "_kz-3";
export var rightContent = "_kz-0";
export var wrappingText = "_kz-4";